import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66bd28b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Bid" }
const _hoisted_2 = {
  key: 2,
  class: "Bid__content"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка заявки...", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "content__header" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "ml-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выше нормы себестоимости", -1))
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "bg-white flex items-center justify-between p-4 mt-3"
}
const _hoisted_14 = { class: "flex flex-col gap-2" }
const _hoisted_15 = {
  key: 0,
  class: "fas fa-check mr-2 text-green-500"
}
const _hoisted_16 = {
  key: 1,
  class: "fas fa-exclamation mr-4"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation mr-4" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Необходимо подтверждение Руководителя Операционного Управления ", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_22 = { class: "content__body" }
const _hoisted_23 = {
  key: 0,
  class: "BidContent__box"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Общая информация", -1))
const _hoisted_25 = { class: "mt-3" }
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = { class: "BidContent__row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Перевозчик", -1))
const _hoisted_29 = { class: "BidContent__row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Направление", -1))
const _hoisted_31 = { class: "BidContent__row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Грузоотправитель", -1))
const _hoisted_33 = { class: "BidContent__row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Адрес загрузки", -1))
const _hoisted_35 = { class: "BidContent__row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Дата загрузки", -1))
const _hoisted_37 = { class: "BidContent__row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Контактное лицо, тел.", -1))
const _hoisted_39 = { class: "BidContent__row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Грузополучатель", -1))
const _hoisted_41 = { class: "BidContent__row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Адрес разгрузки", -1))
const _hoisted_43 = { class: "BidContent__row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Дата разгрузки", -1))
const _hoisted_45 = { class: "BidContent__row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Контактное лицо, тел.", -1))
const _hoisted_47 = { class: "BidContent__row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Номер заказа", -1))
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 1,
  class: "BidContent__box"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Трех. стор. договор", -1))
const _hoisted_52 = { class: "mt-3" }
const _hoisted_53 = { class: "w-full" }
const _hoisted_54 = { class: "BidContent__row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Номер договора", -1))
const _hoisted_56 = { class: "BidContent__row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Дата договора", -1))
const _hoisted_58 = {
  key: 2,
  class: "BidContent__box"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Комментарии по себестоимости", -1))
const _hoisted_60 = { class: "mt-3" }
const _hoisted_61 = { class: "w-full" }
const _hoisted_62 = {
  key: 0,
  class: "whitespace-nowrap"
}
const _hoisted_63 = {
  key: 1,
  class: "whitespace-nowrap"
}
const _hoisted_64 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_65 = {
  key: 3,
  class: "BidContent__box"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Характеристики груза", -1))
const _hoisted_67 = { class: "mt-3" }
const _hoisted_68 = { class: "w-full" }
const _hoisted_69 = { class: "BidContent__row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Характер груза, вес, объём ", -1))
const _hoisted_71 = { class: "BidContent__row" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Страхование", -1))
const _hoisted_73 = { class: "BidContent__row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Тип кузова", -1))
const _hoisted_75 = { class: "BidContent__row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Температурный режим", -1))
const _hoisted_77 = { class: "BidContent__row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Стоимость перевозки", -1))
const _hoisted_79 = { class: "BidContent__row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Срок и форма оплаты", -1))
const _hoisted_81 = {
  key: 4,
  class: "BidContent__box"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__title" }, "Данные водителя и ТС", -1))
const _hoisted_83 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_84 = { class: "w-full" }
const _hoisted_85 = { class: "BidContent__row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "ФИО собственника ТС", -1))
const _hoisted_87 = { class: "BidContent__row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "ФИО водителя", -1))
const _hoisted_89 = { class: "BidContent__row" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Телефон", -1))
const _hoisted_91 = { class: "BidContent__row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Номер технического паспорта ", -1))
const _hoisted_93 = { class: "BidContent__row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Гос. номер авто", -1))
const _hoisted_95 = { class: "BidContent__row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Тип Т/С", -1))
const _hoisted_97 = { class: "BidContent__row" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Марка авто", -1))
const _hoisted_99 = { class: "BidContent__row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Гос. номер прицепа", -1))
const _hoisted_101 = { class: "BidContent__row" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Номер удостоверения личности ", -1))
const _hoisted_103 = { class: "BidContent__row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Дата выдачи удостоверения личности ", -1))
const _hoisted_105 = { class: "BidContent__row" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Номер водительского удостоверения ", -1))
const _hoisted_107 = { class: "BidContent__row" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, " Дата выдачи водительского удостоверения ", -1))
const _hoisted_109 = { class: "BidContent__row" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "BidContent__placeholder" }, "Фото тех. паспорта", -1))
const _hoisted_111 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bids_change_ftl_status_form = _resolveComponent("bids-change-ftl-status-form")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_bids_tabs = _resolveComponent("bids-tabs")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_status_changing)
      ? (_openBlock(), _createBlock(_component_bids_change_ftl_status_form, {
          key: 0,
          "bid-id": Number(_ctx.$route.params.id),
          "is-accept": _ctx.state.is_accept_status,
          "is-decline": _ctx.state.is_decline_status,
          onCancel: _ctx.onCancelStatusChange,
          onStatusChanged: _ctx.onStatusChanged
        }, null, 8, ["bid-id", "is-accept", "is-decline", "onCancel", "onStatusChanged"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 1,
          loading: _ctx.state.is_loading,
          text: "При получении заявки произошла ошибка",
          onRefresh: _ctx.loadBid
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ]))
            : (_ctx.state.bid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_page_title, {
                          title: `Заявка №${_ctx.state.bid.id}`
                        }, null, 8, ["title"]),
                        (_ctx.state.bid && _ctx.state.bid.status)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 0,
                              class: _normalizeClass(["ml-3 small", {
                                    yellow: _ctx.state.bid.status.id === 13,
                                    green: _ctx.state.bid.status.id === 14,
                                }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.bid.status.name), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.state.bid.route && _ctx.state.bid.createdAt)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 1,
                              class: "ml-3 small blue flex items-center justify-between"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.state.bid.route), 1),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.createdAt)), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.state.bid.route && _ctx.state.bid.isAboveCostStandard)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 2,
                              class: "red ml-3 small flex items-center justify-between"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          to: `/contracts/${_ctx.state.bid.contractId}`
                        }, {
                          default: _withCtx(() => [
                            (Boolean(_ctx.state.bid))
                              ? (_openBlock(), _createBlock(_component_the_button, {
                                  key: 0,
                                  class: "primary text small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Перейти к договору с перевозчиком ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createVNode(_component_router_link, { to: "/bids" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_the_button, { class: "second text small" }, {
                              default: _withCtx(() => [
                                _hoisted_12,
                                _createTextVNode(" Назад ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  (_ctx.isConfirmShowed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, " Себестоимость перевозки по нормам: " + _toDisplayString(_ctx.state.bid.costStandardValue || 0) + " ₸ (без НДС) ", 1),
                          _createElementVNode("div", null, [
                            _createTextVNode(" Себестоимость перевозки указанная в заявке: " + _toDisplayString(_ctx.state.bid.costDependingOnVat || 0) + " ₸ ", 1),
                            (_ctx.state.bid.isNds)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("(с НДС)")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("(без НДС)")
                                ], 64))
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.isConfirmedByHeadOfTransport)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                              : (_openBlock(), _createElementBlock("i", _hoisted_16)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.headOfTransportConfirmationText), 1)
                          ]),
                          (_ctx.state.bid.confirmedDetails.isNeedSecondConfirmation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.isCanConfirmOrCancel)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_the_button, {
                                class: "small primary",
                                onClick: _ctx.onAccepted
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Подтверждено ")
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_the_button, {
                                class: "small red",
                                onClick: _ctx.onDeclined
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Отказано ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_bids_tabs, {
                    class: "mt-3",
                    value: _ctx.state.currentTab,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.currentTab) = $event))
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.isGeneral)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.carrier ? _ctx.state.bid.carrier.name : '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.route), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.senderCompany
                                                ? _ctx.state.bid.senderCompany.name
                                                : '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.loadAddress || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.dateOfLoad) || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.senderPerson || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.receiverCompany
                                                ? _ctx.state.bid.receiverCompany.name
                                                : '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.unloadAddress || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                _hoisted_44,
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.dateOfUnload) || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.receiverPerson || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                (_ctx.state.bid.ftlBidId)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      target: "_blank",
                                      to: `/ftl-orders/${_ctx.state.bid.ftlBidId}`,
                                      class: "font-semibold text-blue-500"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.state.bid.ftlBidId), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_49, "-"))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isGeneral)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.tripartiteNumber || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.tripartiteDate) || '-'), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isGeneral && _ctx.state.bid.details && _ctx.state.bid.details.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createVNode(_component_table_scroll_wrapper, {
                                loading: _ctx.state.is_loading
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_the_table, {
                                    loading: _ctx.state.is_loading,
                                    columns: _ctx.DetailsColumns,
                                    rows: _ctx.state.bid.details
                                  }, {
                                    td: _withCtx(({ row, column }) => [
                                      (column.key === 'costOfTransportation')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(row.costOfTransportation) + " тг. ", 1))
                                        : (column.key === 'status')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                              _createVNode(_component_cheap, {
                                                class: _normalizeClass(["small", {
                                                            green: [
                                                                'Подтверждено',
                                                                'В пределах нормы',
                                                            ].includes(row.status),
                                                            red: [
                                                                'Отказано',
                                                                'Выше нормы себестоимости',
                                                            ].includes(row.status),
                                                        }])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(row.status || 'Нет статуса'), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(row[column.key] || '-'), 1))
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "columns", "rows"])
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCargo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.natureOfCargo || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.insurance || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.bodyType || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.temperatureRegime || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.costOfTransportation || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.termAndFormOfPayment || '-'), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCourier)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _hoisted_82,
                          (_ctx.state.bid.driver)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _hoisted_86,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.vehicleOwnerFullName || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_87, [
                                    _hoisted_88,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.fullName || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_89, [
                                    _hoisted_90,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.phone || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_91, [
                                    _hoisted_92,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.car_technical_passport || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_93, [
                                    _hoisted_94,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.carNumber || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_95, [
                                    _hoisted_96,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.carType || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_97, [
                                    _hoisted_98,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.carBrand || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_99, [
                                    _hoisted_100,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.trailerLicenseNumber || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_101, [
                                    _hoisted_102,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.identifyCard || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_103, [
                                    _hoisted_104,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.driver.identifyCardDate) || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_105, [
                                    _hoisted_106,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.bid.driver.license || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_107, [
                                    _hoisted_108,
                                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.bid.driver.licenseDate) || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _hoisted_110,
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.bid
                                                .carTechnicalPassportFiles, (file, idx) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          src: file.path,
                                          key: `file-${idx}`,
                                          alt: "carTechnicalPassportFiles",
                                          class: "mb-2"
                                        }, null, 8, _hoisted_111))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
  ]))
}